import Vue from 'vue'
import Vuex from 'vuex'
import ApiService from "@/common/api.service"
import { DialogProgrammatic as Dialog } from 'buefy'
import { APP_INIT, APP_FETCH_LANGUAGES, APP_FETCH_EDUCATION_LEVELS } from "./action.type"
import { SET_APP_MOBILE, SET_APP_LANGUAGES, SET_APP_EDUCATION_LEVELS } from "./mutation.type"

Vue.use(Vuex)

export default {
  state: {
    isMobile: false,
    languages: [],
    educationLevels: [],
  },
  mutations: {
    [SET_APP_MOBILE](state, data) {
      state.isMobile = data
    },
    [SET_APP_LANGUAGES](state, data) {
      state.languages = data
    },
    [SET_APP_EDUCATION_LEVELS](state, data) {
      state.educationLevels = data
    },
  },
  actions: {
    async [APP_INIT](context) {
      let isMobile = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone/i.test(navigator.userAgent)) ? true : false
      context.commit(SET_APP_MOBILE, isMobile)
      await context.dispatch(APP_FETCH_EDUCATION_LEVELS)
    },
    async [APP_FETCH_EDUCATION_LEVELS](context) {
      let response = await ApiService.get("levels", false)
      context.commit(SET_APP_EDUCATION_LEVELS, response.data)
      return
    },
  }
}